<form id="wallet-email-dialog-form" #inclusionForm="ngForm" (ngSubmit)="onSubmit(inclusionForm)">
  <div class="dialog-title" id="wallet-email-dialog-title">
    {{ title }}
  </div>

  <div class="form-fields" id="wallet-email-dialog-fields">
    <div id="wallet-email-dialog-email-wrapper">
      <div>
        <label for="wallet-email-dialog-input-email" class="col-form-label col-form-label-sm" id="wallet-email-dialog-label-email">
          E-mail
        </label>
        <input
          class="form-control form-control-sm"
          [class]="submited && isInvalidEmail(email.invalid) ? 'input-invalid' : ''"
          id="wallet-email-dialog-input-email"
          type="email"
          name="email"
          #email="ngModel"
          maxlength="256"
          [(ngModel)]="alertEmail.email"
          placeholder="Inserir um e-mail válido"
          [appEmailValidator]
          [appEmailBlacklistValidator]="addedEmails"
          [required]="true"
          />
        </div>
        <div
          id="wallet-email-dialog-error-msg"
          [ngClass]="{ 'mandatory-label': true, 'mandatory-label__invalid': submited && isInvalidEmail(email.invalid) }"
          >
          {{getInvalidEmailMessage(email.invalid)}}
        </div>
      </div>

      <div style="margin-bottom: 20px;" id="wallet-email-dialog-position-wrapper">
        <label for="wallet-email-dialog-input-position" class="col-form-label col-form-label-sm" i18n="@@positionName" id="wallet-email-dialog-label-position">
        Puesto
      </label>
        <input
          class="form-control form-control-sm"
          id="wallet-email-dialog-input-position"
          type="text"
          name="position"
          maxlength="100"
          [(ngModel)]="alertEmail.position"
          placeholder="<Campo opcional>"
          />
        </div>

        @if (isEditing) {
          <div class="status-field" id="wallet-email-dialog-status-wrapper">
            <span id="wallet-email-dialog-span-status">Status:</span>
            <mat-slide-toggle
              id="wallet-email-dialog-toggle-status"
              labelPosition="before"
              name="active"
              [checked]="alertEmail.status"
              [(ngModel)]="alertEmail.status"
              color="primary"
              >
            </mat-slide-toggle>
          </div>
        }
      </div>

      <div class="buttons-container" id="wallet-email-dialog-actions">
        <app-button
          id="wallet-email-dialog-btn-cancel"
          (click)="handleCancel()"
          [buttonStyle]="'outline'"
          i18n="@@cancel"
          >
      Cancelar
    </app-button>

        <app-button
          id="wallet-email-dialog-btn-submit"
          type="submit"
          [disabled]="!hasAnyChange"
          >
          {{ confirmButtonText }}
        </app-button>
      </div>
    </form>
